import {
    Autocomplete,
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    Typography,
} from '@mui/material';
import { DataGrid, esES } from '@mui/x-data-grid';
import { useCallback, useEffect, useState } from 'react';
import { sendRequest } from '../../../../services/request';
import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import {
    Cancel,
    CheckBox,
    CheckBoxOutlineBlank,
    Close,
    DoneAll,
    Download,
    Feedback,
    FilePresent,
} from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DataGridStyle } from '../../../../styles/DataGridSytle';
import { NumericFormat, numericFormatter } from 'react-number-format';
import ListHeader from './listHeader';
import RechazoModal from './modalRechazo';
import ModalConfirmacion from './ModalConfirmacion';

dayjs.extend(weekOfYear);

const empresaEnvioOptions = [
    'Mensajero local',
    'Uno express',
    'Recoge en oficina',
];

const EnviosClientesFinales = ({ pais }) => {
    const [rows, setRows] = useState([]);
    const [limit, setLimit] = useState(50);
    const [page, setPage] = useState(0);
    const [rowCount, setRowCount] = useState(null);
    const [rowToUpdate, setRowToUpdate] = useState(null);

    // Filtros
    const [filtros, setFiltros] = useState({
        nombreDonante: '',
        promotor: '',
        semanaPreventa: '',
        semanaCierre: '',
    });

    // tarjetones
    const [tarjetones, setTarjetones] = useState([]);

    //Condicionales
    const [loading, setLoading] = useState(true);
    const [recargar, setRecargar] = useState(false);

    // Modales
    const [open, setOpen] = useState({
        imagen: false,
        confirmacion: false,
        rechazo: false,
    });
    const [isEditingObs, setIsEditingObs] = useState(false);

    // Modal Imagen
    const [previewUrl, setPreviewUrl] = useState(null);
    const [fileName, setFileName] = useState('');

    const location = useLocation();
    const URL = process.env.REACT_APP_API_URL;

    const campana = location.state?.campana || '';
    //const fieldsToExport = ['cliente', 'destino'];

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const res = await sendRequest(
                    'get',
                    `${URL}/${pais}/envio?page=${page}&limit=${limit}&campanaId=${campana.id}&nombreDonante=${filtros.nombreDonante}&promotor=${filtros.promotor}&semanaPreventa=${filtros.semanaPreventa}&semanaCierre=${filtros.semanaCierre}&validacion_bdd=1`,
                );

                setLoading(false);
                setRows(res.data.items);
                setRowCount(res.data.meta.totalItems);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, [
        URL,
        pais,
        page,
        limit,
        campana,
        recargar,
        filtros.nombreDonante,
        filtros.promotor,
        filtros.semanaPreventa,
        filtros.semanaCierre,
    ]);

    useEffect(() => {
        const fetchData = async () => {
            const res = await sendRequest(
                'get',
                `${URL}/${pais}/tarjeton/unpaginated?campanaId=${campana.id}&sin_envio=1`,
            );
            setTarjetones(res.data);
        };
        fetchData();
    }, [URL, pais, campana]);

    const columns = [
        /* {
            field: 'numero',
            headerName: 'Número',
            flex: 0.5,
            headerClassName: 'header',
            sortable: false,
            renderCell: ({ row }) => row.id,
        }, */
        {
            field: 'cliente',
            headerName: campana.division.id === 1 ? 'Cliente' : 'Donante',
            flex: 1,
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
            valueFormatter: ({ value }) =>
                `${value?.nombres} ${value?.apellidos ? value?.apellidos : ''}`,
            renderCell: ({ row }) => (
                <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {`${row?.cliente?.nombres} ${
                        row?.cliente?.apellidos ? row?.cliente.apellidos : ''
                    }`}
                </Box>
            ),
        },
        {
            field: 'celular',
            headerName: 'Celular',
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
            renderCell: ({ row }) => row?.cliente?.celular,
        },
        {
            field: 'numero_tarjeton',
            headerName:
                campana.division.id === 1
                    ? '# Tarjeton'
                    : '# Tarjeta / Cert. / Boleto',
            flex: 1.5,
            headerClassName: 'header',
            sortable: false,
            editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: ({ row }) => {
                //Si es digital la campaña, el numero del certificado es creado desde jotform
                if (row?.campana?.es_digital) {
                    return row?.numero_certificado_digital;
                }
                return (
                    <Autocomplete
                        disabled={row.estado.id === 9 || row.cantidad <= 0}
                        multiple
                        disableCloseOnSelect
                        disablePortal
                        fullWidth
                        value={row?.tarjetones}
                        options={tarjetones}
                        getOptionLabel={(option) => option?.numero}
                        getOptionDisabled={(option) =>
                            row?.tarjetones.length >= row.cantidad
                        }
                        size="small"
                        onChange={(event, newValue) =>
                            handleChangeTarjeton(newValue, row)
                        }
                        renderOption={(props, option, { selected }) => (
                            <li {...props} key={option.id}>
                                <Checkbox
                                    sx={{
                                        ml: -1,
                                    }}
                                    icon={
                                        <CheckBoxOutlineBlank fontSize="small" />
                                    }
                                    checkedIcon={<CheckBox fontSize="small" />}
                                    checked={selected}
                                />
                                {option.numero}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder=""
                                variant="standard"
                            />
                        )}
                    ></Autocomplete>
                );
            },
        },
        {
            field: 'archivo_adjunto',
            headerName: 'Comprobante de Pago',
            headerClassName: 'header',
            sortable: false,
            flex: 0.8,
            headerAlign: 'center',
            align: 'center',
            renderCell: ({ row }) => {
                const archivo =
                    row?.archivo_adjunto || row?.archivo_adjunto_jotform;
                return (
                    <IconButton
                        disabled={!archivo}
                        color="primary"
                        onClick={() => {
                            return handlePreview(
                                archivo,
                                `Comprobante de pago - ${row?.nombres} ${
                                    row?.apellidos || ''
                                }`,
                            );
                        }}
                    >
                        <FilePresent />
                    </IconButton>
                );
            },
        },
        {
            field: 'estado',
            headerName: 'Estado',
            flex: 'auto',
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
            renderCell: ({ row }) => {
                //Verifico si el estado es Enviado entonces le agrego el a Cliente o Donante segun la division
                if (row.estado.id === 7) {
                    return `${row.estado?.estado} a ${
                        campana.division.id === 1 ? 'Cliente' : 'Donante'
                    }`;
                }
                return row.estado?.estado;
            },
        },
        {
            field: 'semana_preventa',
            headerName: 'Semana Preventa',
            headerClassName: 'header',
            sortable: false,
            headerAlign: 'center',
            align: 'center',
            renderCell: ({ row }) => dayjs(row.created_at).week(),
        },
        {
            field: 'semana_cierre',
            headerName: 'Semana Cierre',
            headerClassName: 'header',
            sortable: false,
            headerAlign: 'center',
            align: 'center',
            renderCell: ({ row }) =>
                row?.fecha_cierre ? dayjs(row?.fecha_cierre).week() : 'N/A',
        },
        {
            field: 'fecha_envio',
            headerName: 'Fecha Envío',
            flex: 1,
            headerClassName: 'header',
            sortable: false,
            editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: ({ row }) => {
                if (campana?.es_digital && !campana?.con_delivery) {
                    return dayjs(row.created_at).format('DD/MM/YYYY');
                }
                if (row.estado.id >= 7 && campana?.con_delivery) {
                    return (
                        <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale="es"
                        >
                            <DatePicker
                                value={dayjs(row.fecha_envio)}
                                slotProps={{
                                    textField: {
                                        variant: 'standard',
                                    },
                                }}
                                onChange={(value) =>
                                    handleChangeFechaEnvio(value, row)
                                }
                            ></DatePicker>
                        </LocalizationProvider>
                    );
                }
                return 'Sin fecha asignada';
            },
        },
        {
            field: 'acciones',
            type: 'actions',
            cellClassName: 'actions',
            headerName: 'Acciones',
            headerClassName: 'header',
            flex: 2.2,
            renderCell: ({ row }) => {
                const buttonsTitle = {
                    confirmacion: '',
                };

                // Manejo del titulo del boton de confirmacion
                if (row.estado.id === 9)
                    buttonsTitle.confirmacion = 'Entregado';
                else {
                    if (campana.division.id === 1)
                        buttonsTitle.confirmacion = 'Confirmar Entrega';
                    else buttonsTitle.confirmacion = 'Confirmar Donación';
                }
                return (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            minWidth: 200, // Puedes ajustar esto
                        }}
                    >
                        <IconButton
                            disabled={row.estado.id === 9}
                            color="primary"
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                maxWidth: 80,
                                borderRadius: 0,
                            }}
                            onClick={() => handleOpenConfirmar(row)}
                        >
                            <DoneAll />
                            <Typography
                                variant="caption"
                                color="primary"
                                sx={{
                                    textAlign: 'center',
                                    whiteSpace: 'normal',
                                    wordBreak: 'break-word',
                                    maxWidth: 60,
                                    lineHeight: 1.1,
                                }}
                            >
                                {buttonsTitle.confirmacion}
                            </Typography>
                        </IconButton>
                        <IconButton
                            disabled={row.estado.id === 9}
                            color="primary"
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                borderRadius: 0,
                                alignItems: 'center',
                                maxWidth: 80,
                            }}
                            onClick={() => handleOpenRechazar(row, true)}
                        >
                            <Cancel />
                            <Typography
                                variant="caption"
                                color="primary"
                                sx={{
                                    textAlign: 'center',
                                    whiteSpace: 'normal',
                                    wordBreak: 'break-word',
                                    maxWidth: 60,
                                    lineHeight: 1.1,
                                }}
                            >
                                Rechazar Donación
                            </Typography>
                        </IconButton>
                        <IconButton
                            disabled={row.estado.id === 9}
                            color="primary"
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                borderRadius: 0,
                                alignItems: 'center',
                                maxWidth: 80,
                            }}
                            onClick={() => handleOpenRechazar(row, false)}
                        >
                            <Feedback />
                            <Typography
                                variant="caption"
                                color="primary"
                                sx={{
                                    textAlign: 'center',
                                    whiteSpace: 'normal',
                                    wordBreak: 'break-word',
                                    maxWidth: 60,
                                    lineHeight: 1.1,
                                }}
                            >
                                Ver obs.
                            </Typography>
                        </IconButton>
                    </Box>
                );
            },
        },
    ];

    // if (campana.es_digital) {
    //     // Si la campaña es digital, elimino el campo de Fecha Envio, al ser digital no se envia por mensajero
    //     columns.splice(6, 1);
    // }

    // Verifico que la campaña es con delivery
    if (campana.con_delivery) {
        const destinoColumn = [
            {
                field: 'destino',
                headerName: 'Destino',
                flex: 1.5,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                valueGetter: ({ row }) => row?.cliente?.direccion_exacta,
                renderCell: ({ row }) => row?.cliente?.direccion_exacta,
            },
        ];
        columns.splice(2, 0, ...destinoColumn);
    }

    // Verifico si la campaña es publicidad o fundraising
    if (campana.division.id === 1) {
        const pubColumns = [
            {
                field: 'cantidad',
                headerName: 'Cantidad',
                flex: 'auto',
                headerClassName: 'header',
                editable: true,
                sortable: false,
                headerAlign: 'center',
                align: 'center',
                renderCell: ({ row }) => row.cantidad,
            },
            {
                field: 'promotor',
                headerName: 'Promotor',
                flex: 'auto',
                headerClassName: 'header',
                editable: true,
                sortable: false,
                headerAlign: 'center',
                align: 'center',
                renderCell: ({ row }) =>
                    `${row.promotor?.nombres} ${row.promotor?.apellidos}`,
            },
            {
                field: 'medio_pago',
                headerName: 'Medio de Pago',
                flex: 1,
                headerClassName: 'header',
                editable: true,
                sortable: false,
                headerAlign: 'center',
                align: 'center',
                renderCell: ({ row }) => (
                    <div
                        style={{
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                        }}
                    >
                        {row?.medio_pago?.nombre}
                    </div>
                ),
            },
            {
                field: 'numero_guia',
                headerName: 'No. de Guía',
                flex: 1,
                headerClassName: 'header',
                editable: true,
                sortable: false,
                headerAlign: 'center',
                align: 'center',
                renderCell: ({ row }) => row.numero_guia,
            },
            {
                field: 'empresa_envio',
                headerName: 'Canal de Envío',
                flex: 1.5,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                editable: true,
                renderCell: ({ row }) => {
                    return (
                        <Autocomplete
                            disabled={row.estado.id === 9 || row.cantidad <= 0}
                            disablePortal
                            fullWidth
                            value={row.empresa_envio}
                            options={empresaEnvioOptions}
                            getOptionLabel={(option) => option}
                            size="small"
                            onChange={(event, newValue) =>
                                handleChangeEmpresaEnvio(newValue, row)
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder=""
                                    variant="standard"
                                />
                            )}
                        ></Autocomplete>
                    );
                },
            },
        ];
        if (pais === 'panama') {
            pubColumns.splice(2, 1);
        }
        columns.splice(!campana.con_delivery ? 3 : 4, 0, ...pubColumns);
        // Add cantidad to the export fields
        //fieldsToExport.push('cantidad');
    } else if (campana.division.id === 2) {
        const fundColumns = [
            {
                field: 'donacion_inicial',
                headerName: 'Donación Stub',
                flex: 1,
                headerClassName: 'header',
                editable: true,
                sortable: false,
                headerAlign: 'center',
                align: 'center',
                renderCell: ({ row }) => {
                    return numericFormatter(row.donacion_inicial?.toString(), {
                        thousandSeparator: true,
                        prefix: pais === 'colombia' ? '$' : 'B/. ',
                        decimalScale: 2,
                        fixedDecimalScale: true,
                    });
                },
                renderEditCell: ({ row }) => {
                    return (
                        <NumericFormat
                            value={row?.donacion_inicial}
                            customInput={TextField}
                            thousandSeparator
                            fullWidth
                            id="donacion_inicial"
                            variant="outlined"
                            decimalScale={2}
                            fixedDecimalScale
                            /* onValueChange={({ formattedValue, value }) =>
                                setPrecioPorDefecto(value)
                            } */
                            prefix={pais === 'colombia' ? '$' : 'B/. '}
                        />
                    );
                },
            },
            {
                field: 'donacion_total',
                headerName: 'Donación Total Verificado',
                flex: 1,
                headerClassName: 'header',
                editable: true,
                sortable: false,
                headerAlign: 'center',
                align: 'center',
                renderCell: ({ row }) => {
                    return numericFormatter(row.donacion_total?.toString(), {
                        thousandSeparator: true,
                        prefix: pais === 'colombia' ? '$' : 'B/. ',
                        decimalScale: 2,
                        fixedDecimalScale: true,
                    });
                },
                renderEditCell: ({ id, api, field, row }) => {
                    return (
                        <NumericFormat
                            value={row?.donacion_total}
                            customInput={TextField}
                            thousandSeparator
                            fullWidth
                            id="donacion_total"
                            variant="outlined"
                            decimalScale={2}
                            fixedDecimalScale
                            onValueChange={({ value }) => {
                                api.setEditCellValue({
                                    id,
                                    field,
                                    value: parseFloat(value),
                                });
                            }}
                            prefix={pais === 'colombia' ? '$' : 'B/. '}
                        />
                    );
                },
            },
            {
                field: 'promotor',
                headerName: 'Promotor',
                flex: 'auto',
                headerClassName: 'header',
                editable: true,
                sortable: false,
                headerAlign: 'center',
                align: 'center',
                renderCell: ({ row }) =>
                    `${row.promotor?.nombres} ${row.promotor?.apellidos}`,
            },
            {
                field: 'medio_pago',
                headerName: 'Medio de Pago',
                flex: 1,
                headerClassName: 'header',
                editable: true,
                sortable: false,
                headerAlign: 'center',
                align: 'center',
                renderCell: ({ row }) => (
                    <div
                        style={{
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                        }}
                    >
                        {row?.medio_pago?.nombre}
                    </div>
                ),
            },
        ];
        columns.splice(!campana.con_delivery ? 3 : 4, 0, ...fundColumns);
    }

    const handleChangeTarjeton = async (newValue, envio) => {
        try {
            for (const tarjeton of newValue) {
                await sendRequest(
                    'patch',
                    `${URL}/${pais}/tarjeton/${tarjeton.id}`,
                    {
                        ...tarjeton,
                        envio: envio.id,
                    },
                );
            }
            setRecargar(!recargar);
        } catch (error) {
            console.log(error);
        }
    };

    const handleChangeFechaEnvio = async (newValue, row) => {
        try {
            await sendRequest('put', `${URL}/${pais}/envio/${row.id}`, {
                ...row,
                fecha_envio: newValue,
            });
            setRecargar(!recargar);
        } catch (error) {
            console.log(error);
        }
    };

    const handleChangeEmpresaEnvio = async (newValue, row) => {
        try {
            await sendRequest('put', `${URL}/${pais}/envio/${row.id}`, {
                ...row,
                empresa_envio: newValue,
                estado: newValue ? 7 : 6,
                fecha_envio: new Date(),
            });
            setRecargar(!recargar);
        } catch (error) {
            console.log(error);
        }
    };

    const handleOpenConfirmar = (envio) => {
        setOpen({ ...open, confirmacion: true });
        setRowToUpdate(envio);
    };

    const handleOpenRechazar = (envio, isEditingObs) => {
        setOpen({ ...open, rechazo: true });
        setRowToUpdate(envio);
        setIsEditingObs(isEditingObs);
    };

    const handleConfirmarEntrega = async (envio, fechaCierre) => {
        let fechaEnvio = null;
        if (campana.con_delivery) {
            fechaEnvio = dayjs().format('YYYY-MM-DD HH:MM:ss');
        }
        try {
            await sendRequest('put', `${URL}/${pais}/envio/${envio.id}`, {
                ...envio,
                fecha_envio: fechaEnvio || undefined,
                fecha_cierre: dayjs(fechaCierre).format('YYYY-MM-DD'),
                estado: {
                    id: 9,
                    estado: 'Afiliado',
                },
                confirmado: true,
            });
            setRecargar(!recargar);
        } catch (error) {
            console.log(error);
        }
    };

    const handlePaginationChange = (event) => {
        setPage(event.page);
        setLimit(event.pageSize);
    };

    const handleRowUpdate = useCallback(
        async (newRow, originalRow) => {
            const res = await sendRequest(
                'put',
                `${URL}/${pais}/envio/${newRow.id}`,
                {
                    ...newRow,
                    estado: newRow.empresa_envio
                        ? {
                              id: 7,
                              estado: 'Enviado a Cliente',
                          }
                        : {
                              id: 6,
                              estado: 'Preventa',
                          },
                },
            );
            return res.data;
        },
        [URL, pais],
    );

    const handleRowRechazo = async (observacion) => {
        await sendRequest('put', `${URL}/${pais}/envio/${rowToUpdate.id}`, {
            observacion,
            confirmado: false,
        });
        setRecargar(!recargar);
    };

    const handleRowUpdateError = (error) => {
        console.log(error);
    };

    const handleIsEditable = ({ row, field }) => {
        let isEditable = false;
        switch (field) {
            case 'numero_tarjeton':
                if (
                    !row.campana?.es_digital &&
                    row.cantidad > 0 &&
                    row.estado.id !== 9
                )
                    isEditable = true;
                break;
            case 'cantidad':
                if (row.cantidad >= 0 && row.estado.id !== 9) isEditable = true;
                break;
            case 'numero_guia':
                if (row.cantidad > 0 && row.estado.id !== 9) isEditable = true;
                break;
            case 'empresa_envio':
                if (row.cantidad > 0 && row.estado.id !== 9) isEditable = true;
                break;
            case 'fecha_envio':
                if (row.fecha_envio && campana.con_delivery) isEditable = true;
                break;
            case 'donacion_total':
                if (row.estado.id !== 9) isEditable = true;
                break;
            default:
                isEditable = false;
                break;
        }
        return isEditable;
    };

    /**
     * Realiza la validacion de las filas que cumplen con estado en enviado a cliente para poder hacer el export
     * @param  {{string, Object}}  params Parametros del data grid, en esta función solo se usan el field y row
     * @return {string}      Devuelve el nombre del className segun el campo
     */
    /*  */
    const handleGetClassName = ({ field, row }) => {
        switch (field) {
            case 'numero_tarjeton':
            case 'empresa_envio':
                if (row.cantidad > 0 && row.estado.id !== 9)
                    return 'custom-editable';
                break;
            default:
                break;
        }
    };

    const handleRowClassName = ({ field, row }) => {
        if (row.confirmado === null) {
            return 'row-pendiente';
        }
        if (row.confirmado) return 'row-confirmado';
        return 'row-no-confirmado';
    };

    /**
     * Realiza la validacion de las filas que cumplen con estado en enviado a cliente para poder hacer el export
     * @param  {import('@mui/x-data-grid').GridCsvGetRowsToExportParams} [params] apiRef del Datagrid
     * @return {number[]}      Devuleve el listado de los items que se quieren exportar
     */
    /*  */
    /* const handleRowsToExport = (params) => {
        const rowsIds = rows
            .filter((item) => item.estado.estado === 'Enviado a Cliente')
            .map((item) => item.id);
        return rowsIds;
    }; */

    const handlePreview = (base64Url, nombre) => {
        setPreviewUrl(base64Url);
        setFileName(nombre);
        setOpen({ ...open, imagen: true });
    };

    const handleClose = () => {
        setOpen({ ...open, imagen: false });
        setPreviewUrl(null);
        setFileName('');
    };

    const handleDownload = () => {
        if (!previewUrl) return;

        const link = document.createElement('a');
        link.href = previewUrl;
        link.download = fileName || 'documento';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <>
            <Box sx={{ height: '100%', width: '100%' }}>
                <Typography
                    variant="h4"
                    color="primary"
                    sx={{
                        textAlign: 'start',
                        marginLeft: '10px',
                        marginTop: '20px',
                    }}
                >
                    Validación BDD y Delivery / {campana.nombre}
                </Typography>
                <ListHeader filtros={filtros} setFiltros={setFiltros} />
                <DataGrid
                    localeText={
                        esES.components.MuiDataGrid.defaultProps.localeText
                    }
                    disableColumnSelector
                    disableDensitySelector
                    disableColumnFilter
                    disableColumnMenu
                    disableRowSelectionOnClick
                    loading={loading}
                    initialState={{
                        pagination: {
                            paginationModel: { pageSize: limit },
                        },
                    }}
                    rows={rows ? rows : []}
                    columns={columns}
                    paginationMode="server"
                    rowCount={rowCount ? rowCount : 0}
                    onPaginationModelChange={handlePaginationChange}
                    processRowUpdate={handleRowUpdate}
                    onProcessRowUpdateError={handleRowUpdateError}
                    isCellEditable={handleIsEditable}
                    getCellClassName={handleGetClassName}
                    getRowClassName={handleRowClassName}
                    getRowHeight={() => 'auto'}
                    sx={[
                        DataGridStyle,
                        {
                            //Hace el cambio del color de los campos editables
                            '& .MuiDataGrid-cell--editable': {
                                border: 1,
                                borderColor: '#ffffff',
                                bgcolor: '#016A8225', // Los ultimos digitos son la transparencia (25%)
                            },
                            '& .MuiDataGrid-virtualScroller': {
                                minHeight: '30vh',
                            },
                            '& .row-pendiente': {
                                backgroundColor: 'envio_pendiente.main',
                            },
                            '& .row-confirmado': {
                                backgroundColor: 'envio_confirmado.main',
                            },
                            '& .row-no-confirmado': {
                                backgroundColor: 'envio_no_confirmado.main',
                            },
                        },
                    ]}
                />
            </Box>
            <ModalConfirmacion
                open={open.confirmacion}
                onClose={() => setOpen({ ...open, confirmacion: false })}
                onConfirm={(selectedDate) =>
                    handleConfirmarEntrega(rowToUpdate, selectedDate)
                }
                campana={campana}
            />
            <RechazoModal
                open={open.rechazo}
                onClose={() => setOpen({ ...open, rechazo: false })}
                onSubmit={handleRowRechazo}
                isEditing={isEditingObs}
                row={rowToUpdate}
            ></RechazoModal>
            {/* Modal Imagen */}
            <Dialog
                open={open.imagen}
                onClose={handleClose}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle sx={{ m: 0, p: 2 }}>
                    Comprobante de{' '}
                    {campana.division.id === 2 ? 'Donación' : 'Pago'}
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers style={{ height: '80vh' }}>
                    {previewUrl && previewUrl.includes('application/pdf') ? (
                        <iframe
                            src={previewUrl}
                            style={{ width: '100%', height: '100%' }}
                            title="Preview PDF"
                        />
                    ) : (
                        <img
                            src={previewUrl}
                            alt="Preview"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                            }}
                        />
                    )}
                </DialogContent>

                <DialogActions>
                    <Button
                        variant="contained"
                        startIcon={<Download />}
                        onClick={handleDownload}
                        color="primary"
                    >
                        Descargar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default EnviosClientesFinales;
